import React, {useState} from "react";
import {Button, Layout, Text, TextField} from "@audi/audi-ui-react";
import {api} from "../../axios";
import qs from "qs";
import {useDispatch} from "react-redux";
import {handleResponse} from "../../common/utils";
import {clearModal, setModal} from "../../redux/modal";
import {useHistory} from "react-router";

export function Login() {
    const dispatch = useDispatch();
    const history = useHistory();
    
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    
    const loginHandler = () => {
        api.post("/userAuth", qs.stringify({email, password}))
            .then(res => handleResponse(dispatch, res));
    };
    
    const handleRegistration = e => {
        e.preventDefault();
        dispatch(clearModal());
        history.push("/#regisztracio");
    };
    
    const handleForgottenPassword = e => {
        e.preventDefault();
        dispatch(setModal({name: "forgottenPassword"}))
    };
    
    return (
        <Layout justify="center" direction="column">
            <Text variant="order2">
                Bejelentkezés
            </Text>
            <TextField value={email} onChange={e => setEmail(e.target.value)} spacing={["s"]} label="Email"
                       inputId="login-email" type="text" maxLength={200}
                       name="login-email-field" pattern={null} required/>
            <TextField value={password} onChange={e => setPassword(e.target.value)} spacing={["s"]} label="Jelszó"
                       inputId="login-password" type="password" maxLength={9999}
                       name="login-password-field" pattern={null} required/>
            <Text spacing={["s"]} variant="copy1">
                <a onClick={handleForgottenPassword} href="#0">Elfelejtetted a jelszavad?</a>
            </Text>
            <Button spacing={["s"]} variant="primary" onClick={loginHandler}>Bejelentkezés</Button>
            <Text variant="copy1">
                <a onClick={handleRegistration} href="#0">Még nem regisztráltál? Tedd meg most!</a>
            </Text>
        </Layout>
    );
}